<template>
    <div class="outer-box">
        <div class="m-portlet  m-portlet--head-sm left  m-b-0">
            <div class="m-portlet__head">
                <div class="m-portlet__head-caption">
                    <div class="m-portlet__head-title">
                        <h3 class="m-portlet__head-text">
                            筛选条件
                        </h3>
                    </div>
                </div>
            </div>
            <div class="m-portlet__body m-portlet__body--small-padding ">
                <el-form label-position="top">
                    <el-form-item label="筛选年级">
                        <el-select v-model="filter.grade_id" clearable  multiple placeholder="请选择年级" @change="handleIndexTeacherPlan()">
                            <el-option
                                    v-for="item in grades"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="筛选学科">
                        <el-select v-model="filter.subject_id"
                                   multiple
                                   clearable
                                   placeholder="请选择"
                                   @change="handleIndexTeacherPlan()">
                            <el-option
                                    v-for="item in subjects"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="选择日期">
                        <div class="block">
                            <el-date-picker
                                    v-model="date"
                                    type="daterange"
                                    align="right"
                                    unlink-panels
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    value-format="yyyy-MM-dd"
                                    :clearable="true"
                                    :picker-options="pickerOptions2"
                                    @change="changeDate(date)">
                            </el-date-picker>
                        </div>
                    </el-form-item>
                    <el-form-item label="">
                        <el-button @click="handleCreateNewTeacherPlan">创建新教案</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="m-portlet right m-b-0">
            <div class="m-portlet__body" :style="{'height':clientHeight-96-61.59+'px'}" v-loading="loading">
                <el-table v-if="!loading"
                          :data="orderTeacherPlans"
                          style="width: 100%"
                          :height="clientHeight-96-61.59-2.2-2-13-20"
                          size="middle">
                    <el-table-column prop="id" label="编号" min-width="5%"></el-table-column>
                    <el-table-column prop="name" label="名称" min-width="10%"> </el-table-column>
                    <el-table-column prop="grade_name" label="年级" min-width="10%"> </el-table-column>
                    <el-table-column prop="subject_name" label="学科" min-width="10%"> </el-table-column>
                    <el-table-column prop="created_date" label="创建日期" min-width="10%"> </el-table-column>
                    <el-table-column label="操作" v-if="powers.includes(2)" min-width="10%">
                        <!--<el-table-column label="操作">-->
                        <template slot-scope="scope">
                            <el-button size="mini" @click="handleTeacherInformation(scope.row.id,scope.row.name)">查看详情
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <div class="m-portlet__foot">
                <!--分页-->
                <div class="text-center">
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="10"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="total">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    // import store from '@/store'

    export default {
        name: "students-list",
        data() {
            return {
                path: '/teacherPlan/list',
                loading: true,
                total: 0,
                currentPage: 1,
                currentPageSize: 10,
                teacherPlans: [],
                date:[],
                grades: [],
                subjects:[],
                pickerOptions2: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                filter:{
                    grade_id: '',
                    subject_id: '',
                    start_date: '',
                    end_date:''
                },
                dialog_CreateTeacherPlan:{
                    name:'',
                    subject_id:'',
                    grade_id:'',
                    button_loading:false
                }
            }
        },
        props: {},
        components: {},
        created() {
            this.handleCreate();
            //this.handleInit();
           // this.handleIndexTeacherPlan();
        },
        beforeDestroy(){
            this.$wApi.removeListen(this.path)
        },
        computed: {
            powers(){
                return this.$store.state.config.powers;
            },
            orderTeacherPlans: function () {
                return this._.values(this.teacherPlans);
            },
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
        },
        methods: {
            changeDate() {
                if (this.date == null) {
                    this.date = ["1000-01-01", "9999-01-01"]
                }
                this.filter.start_date = this.date[0];
                this.filter.end_date = this.date[1];
                this.loading = true;
                this.handleIndexTeacherPlan();
            },
            handleCreate() {
                this.$wApi.addListen(this.path, this.handleData)
            },
            handleData(event, data) {
                switch (event) {
                    case 'subscribe':
                        break;
                    case 'init':
                        this.grades = data.grades;
                        this.subjects = data.subjects;
                        break;
                    case 'list':
                        if (Object.keys(data.teacherPlans).length > 0) {
                            this.teacherPlans = data.teacherPlans;
                        } else {
                            this.teacherPlans = new Object();
                        }
                        this.total = data.total;
                        this.loading = false;
                        break;
                    case 'create_teacherPlan':
                        if (Object.keys(data.teacherPlans).length < this.currentPageSize) {
                            this.$set(this.teacherPlans, data.teacherPlan.id, data.teacherPlan)
                        }
                        this.total++;
                        this.$Win.closeModal();
                        this.$store.dispatch('addView', {
                            'title': data.teacherPlan.name,
                            'path': '/teacherPlan/' +  data.teacherPlan.id,
                            'closable': true
                        });
                        this.router.push({path: '/teacherPlan/' + data.teacherPlan.id})
                        break;
                }
            },
            handleInit() {
                this.$wApi.send(this.path, 'init', {})
            },
            handleIndexTeacherPlan(currentPage=1) {
                if (currentPage===1){
                    this.currentPage=1
                }
                this.$wApi.send(this.path, 'list', {
                    'currentPage': currentPage,
                    'currentPageSize': this.currentPageSize,
                    'filter': this.filter,
                });
            },
            handleTeacherInformation(teacherPlan_id, title) {
                this.$store.dispatch('addView', {
                    'title': title,
                    'path': '/teacherPlan/' + teacherPlan_id,
                    'closable': true
                });
                this.router.push({path: '/teacherPlan/' + teacherPlan_id})
            },
            handleSizeChange(val) {
                this.currentPageSize = val;
                this.loading = true;
                this.handleIndexTeacherPlan(this.currentPage)
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.loading = true;
                this.handleIndexTeacherPlan(this.currentPage)
            },
            handleCreateNewTeacherPlan(){
                this.$Win.openModal('Dialog_CreateTeacherPlan', 350, 400, '创建教案');
            }
        }
    }
</script>

<style scoped lang="scss">
    .left {
        float: left;
        width: 420px;
    }

    .right {
        margin-left: 425px;
    }
</style>
